export const PARTNER = 'Partner';
export const ADMIN = 'Admin';
export const MANAGER = 'Manager';
export const CANDIDATE = 'Candidate';
export const CORPCLIENT = 'CorpClient';
